import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { enableProdMode, LOCALE_ID } from '@angular/core';
import '@angular/common/locales/global/nl';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbAccordionModule, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularIbanModule } from 'angular-iban';
import { NgxUiLoaderModule, NgxUiLoaderConfig } from 'ngx-ui-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { AppComponent } from './app/app.component';
import { routes } from './app/app-routing.module';
import { environment } from './environments/environment';
import { JwtInterceptor } from './app/authentication/helpers/jwt.interceptor';
import { ErrorInterceptor } from './app/authentication/helpers/error.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from './app/authentication/authentication.service';
import { ApiService } from './app/services/api.service';
import { ValuationService } from './app/services/valuation.service';
import { AuthGuardService } from './app/authentication/auth-guard.service';
import { NgbDateCustomParserFormatter } from './app/services/custom-date';
import { MaintenanceInterceptor } from './app/authentication/helpers/maintenance.interceptor';
import { MaintenanceService } from './app/authentication/helpers/maintenance.service';
import { HeaderComponent } from './app/header/header.component';
import { UpdateService } from './app/services/update.service';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  hasProgressBar: false,
  fgsSize: 200
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(
      BrowserModule,
      ReactiveFormsModule,
      NgbModule,
      NgbAccordionModule,
      FontAwesomeModule,
      AngularIbanModule,
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
    ),
    AuthenticationService,
    ApiService,
    ValuationService,
    AuthGuardService,
    MaintenanceService,
    HeaderComponent,
    UpdateService,
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MaintenanceInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'nl' }
  ]
}).catch(err => console.error(err));
